import { Box, styled } from '@mui/material';
import { Typography } from '@forethought-technologies/forethought-elements';
import { IconHeart } from '@tabler/icons-react';
import { selectCsatStates, setCsatStatesByKey } from 'reducers/workflows';
import { useAppDispatch, useAppSelector } from 'hooks';
import { selectCsatConfigRevamped } from 'reducers/config';
import { LOW_RATING_CAP } from './constants';
import safeLinkifyHtml from 'utils/safeLinkifyHtml';
import { CsatCloseButton } from './CsatCloseButton';
import sanitizeHtml from 'utils/sanitizeHtml';

export const CsatSurveySubmitted = () => {
  const dispatch = useAppDispatch();
  const csatConfig = useAppSelector(selectCsatConfigRevamped);
  const csatStates = useAppSelector(selectCsatStates);

  if (!csatConfig) {
    return null;
  }

  const { rating: selectedRating } = csatStates;

  const {
    should_show_submit_confirmation_message:
      shouldShowSubmitConfirmationMessage,
    should_use_rating_based_submit_message: shouldUseRatingBasedSubmitMessage,
    submit_confirmation_message: submitConfirmationMessage,
    submit_message_for_high_ratings: submitMessageForHighRatings,
    submit_message_for_low_ratings: submitMessageForLowRatings,
  } = csatConfig;

  const ratingBasedSubmitMessage = (
    <Typography variant='font14'>
      <div
        // eslint-disable-next-line react/forbid-dom-props
        dangerouslySetInnerHTML={{
          __html: safeLinkifyHtml(
            sanitizeHtml(
              selectedRating >= LOW_RATING_CAP
                ? submitMessageForHighRatings
                : submitMessageForLowRatings,
            ),
          ),
        }}
      />
    </Typography>
  );

  const normalSubmitMessage = (
    <Typography variant='font14'>
      {shouldShowSubmitConfirmationMessage
        ? submitConfirmationMessage
        : 'Thank you for your feedback!'}
    </Typography>
  );

  return (
    <Box
      alignItems='center'
      display='flex'
      flex={1}
      flexDirection='column'
      gap='8px'
      justifyContent='center'
    >
      <Box
        dir='auto'
        sx={{
          display: 'flex',
          gap: '8px',
          justifyContent: 'space-between',
        }}
      >
        {shouldUseRatingBasedSubmitMessage
          ? ratingBasedSubmitMessage
          : normalSubmitMessage}
        <Box sx={{ alignSelf: 'flex-start' }}>
          <CsatCloseButton />
        </Box>
      </Box>
      <IconHeart size={20} />
      <UnderlinedTextButton
        onClick={() => {
          dispatch(
            setCsatStatesByKey({
              isEditing: true,
            }),
          );
        }}
      >
        Update feedback
      </UnderlinedTextButton>
    </Box>
  );
};

const UnderlinedTextButton = styled('button')`
  outline: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  background-color: transparent;
  color: ${props => props.theme.palette.colors.grey[600]};
`;
